/**
 * Shared backdrop for every full-screen popup — one consistent scrim
 * everywhere rather than each component picking its own darkness. z-50
 * matches Sheet/Dialog Content, so a popup opened from an already-open one
 * (e.g. Share from inside the creator drawer) still paints its scrim above
 * it — later-mounted wins the DOM-order tie at equal z-index.
 */
export const MODAL_SCRIM_CLASS =
  'data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:animate-in data-[state=open]:fade-in-0 motion-reduce:animate-none! fixed inset-0 z-50 bg-black/25';

export const REDUCED_MOTION_DIALOG_CLASS = 'motion-reduce:animate-none! motion-reduce:transition-none!';
